import React from 'react';
import { useTranslation } from 'react-i18next';
import horseltestImage from '../images/horseltest/F32C59D2-405A-49D2-8BB4-0590A2994315.png';

const Horseltest: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#0A4A7A] mb-4">{t('horseltest.title')}</h1>
        <h2 className="text-2xl text-[#0A4A7A] mb-8">{t('horseltest.subtitle')}</h2>
        <p className="text-gray-700 text-lg mb-4 max-w-3xl">{t('horseltest.text1')}</p>
        <p className="text-gray-700 text-lg mb-4 max-w-3xl">{t('horseltest.text2')}</p>
        <p className="text-gray-700 text-lg mb-0 max-w-3xl">{t('horseltest.text3')}</p>
        <div className="-mt-24 -mb-24">
          <img src={horseltestImage} alt="Hörseltest" className="max-w-2xl w-full mx-auto rounded-lg" />
        </div>
        <div className="bg-[#0A4A7A] rounded-lg p-8 text-center">
          <h3 className="text-2xl font-semibold mb-4 text-white">{t('horseltest.bookTitle')}</h3>
          <p className="text-gray-200 mb-6">{t('horseltest.bookDesc')}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:072-334 47 74" className="bg-white text-[#0A4A7A] px-6 py-3 rounded font-semibold hover:bg-gray-100 transition-colors">{t('services.call')} 072-334 47 74</a>
            <a href="https://www.bokadirekt.se/places/varmdo-horsel-134414" target="_blank" rel="noopener noreferrer" className="border border-white text-white px-6 py-3 rounded font-semibold hover:bg-white/10 transition-colors">{t('services.bookTime')}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Horseltest;
